require('../../shared/singleGameService');
require('../../shared/singleClipService');

angular.module('app.player.clipsController', [
  'app.shared.singleGameService',
  'app.shared.singleClipService'
])
  .controller('app.player.clipsController', [
    '$scope',
    'app.shared.singleGameService',
    'app.shared.singleClipService',
    '$state',
    function ($scope, singleGame, singleClip, $state) {
      "use strict";

      $scope.game = singleGame;

      $scope.thumbnailUrl = function (clip) {
        if (clip.thumbnail_url) {
          return clip.thumbnail_url;
        }
        return 'images/default/default.jpeg';
      };

      $scope.play = function (clip) {
        if (clip.audio != $scope.selectedAudio) {
          $state.go("app.play", {type: "clip", id: clip.iclipid, audio: clip.audio});
        } else {
          let start = singleClip.transformer.getStartTime(clip);
          $scope.player.seek(start);
        }
      };

      $scope.getClips = () => {
        if (singleGame.data) {
          singleGame.getMoreClips();
        }
      };
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/player/clips/clipsController.js